import { render, staticRenderFns } from "./ConfirmSafetyTraining.vue?vue&type=template&id=17740c42&scoped=true"
import script from "./ConfirmSafetyTraining.vue?vue&type=script&lang=js"
export * from "./ConfirmSafetyTraining.vue?vue&type=script&lang=js"
import style0 from "./ConfirmSafetyTraining.vue?vue&type=style&index=0&id=17740c42&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17740c42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VFlex,VForm,VLayout,VTextField})
